var positionFrostedItems = function positionFrostedItems(frostedItems) {
  var parent = frostedItems.closest(".CallToAction");
  var height = parent.outerHeight();
  var parentOffsetTop = parent[0].getBoundingClientRect().top;
  frostedItems.each(function () {
    var inner = this.querySelector(".CallToAction--frosted-inner");
    var boundingBox = this.getBoundingClientRect();
    inner.style.height = height + "px";
    inner.style.left = -boundingBox.left + "px";
    inner.style.top = -(boundingBox.top - parentOffsetTop) + "px";
  });
};

var frostedItems = $(".CallToAction-buttonGroup-button .CallToAction--frosted");

if (frostedItems.length) {
  setTimeout(function () {
    $(window).resize(function () {
      positionFrostedItems(frostedItems);
    });
    positionFrostedItems(frostedItems);
  }, 500);
}